const React = require('react');
const noop = require('mn-utils/noop');
const Ripple = require('../../../../Ripple/');
const {Link} = require('../../../../../../router');

module.exports = ({text, children, url, onClick}) => {
  const component = url ? Link : undefined;
  const href = url ? url : undefined;

  return (
    <Ripple
      className={`
        w152 h45 layoutRow jcC aiC rlv r9 f12 fw7 c0 b1 bs bc0
        (abs|sr9|st50%|xY-50%)>.plus
      `}
      component={component}
      href={href}
      onClick={onClick ? onClick : noop()}
    >
      <span>{text || children}</span>
      <div className="plus">
        >
      </div>
    </Ripple>
  )
}
